<template>
    <div class="box-app-info">
        <div class="container">
            <div class="row">
                <div class="box-app-check-body">
                    <div class="border-box-app-mobile"></div>
                    <div class="download-title-mobile" v-html="dTitle"></div>
                    <div class="box-app-check-body-item">
                        <img class="iphone"  :src="dIphone"/>
                    </div>
                    <div class="box-app-check-body-item  app-check-body-right">
                        <div class="border-box-app"></div>
                        <div class="download-title" v-html="dTitle"></div>
                        <div class="download-info">
                          <div class="download-info-item">
                            <div class="display-flex download-info-item-img">
                              <div class="box_icon upgrade_color">
                                <img :src="upgradeImg"/>
                              </div>
                              <!--<img :src="upgradeImg"/>-->
                            </div>
                            <div class="display-flex download-info-item-right">
                              <div class="download-info-item-title" v-html="upgradeTitle"></div>
                              <div class="download-info-item-description" v-html="upgradeDescription"></div>
                            </div>
                          </div>
                          <div class="download-info-item">
                            <div class="display-flex download-info-item-img">
                              <div class="box_icon news_technology_color">
                                <img :src="newsTechnologyImg"/>
                              </div>
                              <!--<img :src="newsTechnologyImg"/>-->
                            </div>
                            <div class="display-flex download-info-item-right">
                              <div class="download-info-item-title" v-html="newsTechnologyTitle"></div>
                              <div class="download-info-item-description" v-html="newsTechnologyDescription"></div>
                            </div>
                          </div>
                          <div class="download-info-item">
                            <div class="display-flex download-info-item-img">
                              <div class="box_icon guide_color">
                                <img :src="guideImg"/>
                              </div>
                              <!--<img :src="guideImg"/>-->
                            </div>
                            <div class="display-flex download-info-item-right">
                              <div class="download-info-item-title" v-html="guideTitle"></div>
                              <div class="download-info-item-description" v-html="guideDescription"></div>
                            </div>
                          </div>
                            <div class="download-info-item">
                                <div class="display-flex download-info-item-img">
                                  <div class="box_icon promotion_color">
                                    <img :src="promotionImg"/>
                                  </div>
                                    <!--<img :src="promotionImg"/>-->
                                </div>
                                <div class="display-flex download-info-item-right">
                                    <div class="download-info-item-title" v-html="promotionTitle"></div>
                                    <div class="download-info-item-description" v-html="promotionDescription"></div>
                                </div>
                            </div>
                            <div class="download-link">
                                <a target="_blank" :href="linkAppStore" class="image-store">
                                    <img :src="dAppStore"/>
                                </a>
                                <a target="_blank" :href="linkCHPlay" class="image-store">
                                    <img :src="dCHPlay"/>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            lstData: Array
        },
        data() {
            return {
                dTitle: '',
                dIphone: window.origin + '/assets/images/Mock-up Hong Ky app.png',
                dAppStore: window.origin + '/assets/images/Appstore.png',
                dCHPlay: window.origin + '/assets/images/GGplay.png',
                promotionTitle: '',
                promotionImg: window.origin + '/assets/images/vector_5573_0.png',
                promotionDescription: '',
                upgradeTitle: '',
                upgradeImg: window.origin + '/assets/images/vector_5573_1.png',
                upgradeDescription: '',
                guideTitle: '',
                guideImg: window.origin + '/assets/images/vector_5573_2.png',
                guideDescription: '',
                newsTechnologyTitle: '',
                newsTechnologyImg: window.origin + '/assets/images/vector_5573_3.png',
                newsTechnologyDescription: '',
                linkAppStore: '',
                linkCHPlay: ''
            }
        },
        mounted () {
            if (this.lstData != undefined && this.lstData && Object.keys(this.lstData).length > 0) {
                var objTitle = this.lstData.filter(a => a.key == 'PAGE_CHECKER_TITLE_DOWNLOAD');
                if (objTitle && Object.keys(objTitle).length) {
                    this.dTitle = objTitle[0].value.trim();
                }

              var objNewsTechnologyTitle = this.lstData.filter(a => a.key == 'PAGE_CHECKER_NEWS_TECHNOLOGY_TITLE');
              if (objNewsTechnologyTitle && Object.keys(objNewsTechnologyTitle).length) {
                this.newsTechnologyTitle = objNewsTechnologyTitle[0].value.trim();
              }

              var objNewsTechnologyDescription = this.lstData.filter(a => a.key == 'PAGE_CHECKER_NEWS_TECHNOLOGY_DESCRIPTION');
              if (objNewsTechnologyDescription && Object.keys(objNewsTechnologyDescription).length) {
                this.newsTechnologyDescription = objNewsTechnologyDescription[0].value.trim();
              }

                var objPromotionTitle = this.lstData.filter(a => a.key == 'PAGE_CHECKER_PROMOTION_TITLE');
                if (objPromotionTitle && Object.keys(objPromotionTitle).length) {
                    this.promotionTitle = objPromotionTitle[0].value.trim();
                }
               
                var objPromotionDescription = this.lstData.filter(a => a.key == 'PAGE_CHECKER_PROMOTION_DESCRIPTION');
                if (objPromotionDescription && Object.keys(objPromotionDescription).length) {
                    this.promotionDescription = objPromotionDescription[0].value.trim();
                }

                var objUpgradeTitle = this.lstData.filter(a => a.key == 'PAGE_CHECKER_UPGRADE_TITLE');
                if (objUpgradeTitle && Object.keys(objUpgradeTitle).length) {
                    this.upgradeTitle = objUpgradeTitle[0].value.trim();
                }
                
                var objUpgradeDescription = this.lstData.filter(a => a.key == 'PAGE_CHECKER_UPGRADE_DESCRIPTION');
                if (objUpgradeDescription && Object.keys(objUpgradeDescription).length) {
                    this.upgradeDescription = objUpgradeDescription[0].value.trim();
                }

                var objGuideTitle = this.lstData.filter(a => a.key == 'PAGE_CHECKER_GUIDE_TITLE');
                if (objGuideTitle && Object.keys(objGuideTitle).length) {
                    this.guideTitle = objGuideTitle[0].value.trim();
                }
               
                var objGuideDescription = this.lstData.filter(a => a.key == 'PAGE_CHECKER_GUIDE_DESCRIPTION');
                if (objGuideDescription && Object.keys(objGuideDescription).length) {
                    this.guideDescription = objGuideDescription[0].value.trim();
                }

                var objCHPlay = this.lstData.filter(a => a.key == 'PAGE_CHECKER_CH_PLAY');
                if (objCHPlay && Object.keys(objCHPlay).length) {
                    this.linkCHPlay = objCHPlay[0].value.trim();
                }

                var objAppStore = this.lstData.filter(a => a.key == 'PAGE_CHECKER_APP_STORE');
                if (objAppStore && Object.keys(objAppStore).length) {
                    this.linkAppStore = objAppStore[0].value.trim();
                }
            }
        }
        
    }
</script>

<style lang="scss">
.box-app-info{ margin-top: 91.80pt; padding-bottom: 36.45pt; background: #f5f5f7; position: relative;
    .box-app-check-body{ margin: 0 auto;
        .border-box-app-mobile{display: none; border-bottom:4px solid #f00; width: 80px;}
        .download-title-mobile{display: none; margin-top: 10.80pt;font-size: 24px; font-family: 'Roboto';
            span { display: block;line-height: 1; font-weight: 900;}
        }
        .box-app-check-body-item{ height: 501px; /*min-width: 400px;*/max-width: 450px; float: left;
            img.iphone{max-width: 100%; height: 100%;}
            &.app-check-body-right{ margin-left: 44.42px;
                .border-box-app{border-bottom: 4px solid #f00; width: 138px;}
                .download-title{margin-top: 10.80pt; font-size: 40px; line-height: 47px; font-family: 'Roboto';
                    span { display: block;line-height: 1; font-weight: 900;}
                }
                .download-info{margin-top: 50px;
                  @media (max-width: 480px) {
                    padding: 0px 12px;
                  }
                    .download-info-item{display: flex;  margin-bottom: 10px;/*margin-bottom: 15px;*/ /*margin-left: -10px;*/position: relative;
                        // &:first-child{margin-bottom: 0;}
                        &:last-child{margin-bottom: 0;}
                        .display-flex{
                            &.download-info-item-img{/*width: 80px; height: 80px;*/width: 40px; height: 40px;position: absolute; top: 0px; bottom: 0px; margin: auto; left: 0px;
                                img{max-width: 100%; height: 100%; width: 100%;}
                              .upgrade_color{
                                background: #EC1E2B; box-shadow: 0px 14px 22px -8px rgba(255, 105, 105, 0.5);
                                img{
                                  width: 16.5px;height: 20px
                                }
                              }
                              .news_technology_color{
                                background: #EA971D; box-shadow: 0px 14px 22px -8px rgba(255, 195, 105, 0.5);
                                img{
                                  width: 19.5px;height: 18.7px
                                }
                              }
                              .guide_color{
                                background: #1C1C1E; box-shadow: 0px 14px 22px -8px rgba(141, 141, 141, 0.5);
                                img{
                                  width: 20.1px;height: 15.2px
                                }
                              }
                              .promotion_color{
                                background: #2B9ED5; box-shadow: 0px 14px 22px -8px rgba(0, 178, 255, 0.4);
                                img{
                                  width: 18.3px;height: 18.3px
                                }
                              }
                              .box_icon{
                                img{margin-top: 0px !important;}
                                width: 40px;height: 40px; border-radius: 10px;display: flex; justify-content: center; align-items: center;
                              }
                            }
                            &.download-info-item-right{/*margin-left: 10px;*/margin-left: 64px; vertical-align: text-top; width: calc(100% - 190px);
                              @media (max-width: 480px) {
                                width: 100%!important;
                              }
                                .download-info-item-title{line-height: 22px; font-size: 17px; font-family: 'Roboto'; font-weight: 700; color: #000; margin-bottom: 3px;}
                                .download-info-item-description{font-size: 13px; line-height: 18px; font-family: 'Roboto'; color: #8e8e93;}
                            }
                        }
                    }
                    .download-link{ margin-top: 23px;/*margin-top: 33px;*/
                        .image-store{width: 117.92px; height: 38.25px; display: inline-block; margin-right: 15.65px;
                            &:last-child{margin-right: 0;}
                            img{max-width: 100%; height: 100% !important; width: 100%;}
                        } 
                    }
                }
            }
        }
    }
}

</style>